"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _labelPropTypes = require("../../productTableLabels/defaults/labelPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */

var TableContext = exports.TableContext = /*#__PURE__*/(0, _react.createContext)(null);
TableContext.propTypes = {
  brandTextElements: _propTypes["default"].shape({
    footnotes: _propTypes["default"].object,
    labelGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape(_labelPropTypes.LabelGroupPropTypes)),
    productDDO: _propTypes["default"].func
  }),
  groupDisplayStates: _propTypes["default"].shape({
    0: _propTypes["default"].bool,
    1: _propTypes["default"].bool,
    2: _propTypes["default"].bool,
    3: _propTypes["default"].bool,
    4: _propTypes["default"].bool,
    5: _propTypes["default"].bool
  }),
  visiblePlans: _propTypes["default"].any,
  mobileSettings: _propTypes["default"].shape({
    mobileMode: _propTypes["default"].bool,
    visibilityMap: _propTypes["default"].arrayOf(_propTypes["default"].objectOf(_propTypes["default"].number))
  }),
  AddOnsMap: _propTypes["default"].any,
  AllPlans: _propTypes["default"].any,
  ProductGroupsKeyedByPlanNumber: _propTypes["default"].any,
  ProductGroupFilterExcludesPlan: _propTypes["default"].func,
  onSelectedOptionChange: _propTypes["default"].func,
  onGroupDisplayStateChange: _propTypes["default"].func,
  productsAreMerged: _propTypes["default"].bool,
  selectedOptions: _propTypes["default"].any,
  GetCellCssClass: _propTypes["default"].func
};